import { render, staticRenderFns } from "./JciProgramPaymentApproval.vue?vue&type=template&id=53cb3514"
import script from "./JciProgramPaymentApproval.vue?vue&type=script&lang=js"
export * from "./JciProgramPaymentApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports